export const faqs = [
  {
    question: '什么是韩漫？',
    answer: '韩漫（Manhwa）是指韩国创作的漫画作品，通常采用全彩绘制和纵向滚动阅读方式，与日本漫画（Manga）在画风和阅读体验上有显著区别。韩漫以其精美的画风、丰富的色彩和引人入胜的故事情节受到全球漫迷的喜爱。',
  },
  {
    question: '在哪里可以免费观看韩漫？',
    answer: '目前市面上有多个提供免费韩漫阅读的平台，如韩漫屋、韩漫世界等。这些平台提供大量免费韩漫资源，用户可以直接在线观看。此外，韩漫网和韩漫之家也有大量免费内容区域，是漫迷们经常光顾的韩漫网址。',
  },
  {
    question: '韩漫和日漫有什么区别？',
    answer: '韩漫和日漫的主要区别在于：韩漫以全彩绘制为主，采用纵向滚动阅读方式，更适合手机阅读；日漫以黑白为主，延续传统翻页阅读方式。在题材上，韩漫更偏向恋爱、职场等现代题材，而日漫在热血冒险类更为突出。',
  },
  {
    question: '如何选择适合自己的韩漫平台？',
    answer: '选择韩漫平台时建议考虑以下因素：资源丰富度（是否收录你想看的韩漫）、阅读体验（界面是否舒适流畅）、价格（免费还是付费）、更新速度（新章节是否及时）。新手推荐从韩漫网或韩漫之家开始使用。',
  },
  {
    question: '韩漫平台需要付费吗？',
    answer: '不同的韩漫平台收费模式各异。像韩漫屋提供完全免费的阅读服务；韩漫网和韩漫之家采用部分免费+付费的模式，热门新作可能需要付费或等待免费解锁。建议根据个人预算和需求选择合适的平台。',
  },
  {
    question: '韩漫导航网站收录了哪些韩漫平台？',
    answer: '我们的韩漫导航网站汇集了当前最热门的韩漫平台入口，包括韩漫网、韩漫之家、韩漫屋、韩漫吧、韩漫天堂、漫客韩漫、韩漫汇、韩漫阁、韩漫世界、韩漫集等，覆盖免费和付费、综合和垂直等多种类型，是完整的韩漫网址大全。',
  },
  {
    question: '如何在手机上流畅阅读韩漫？',
    answer: '绝大多数韩漫平台都针对手机端进行了优化，下载对应平台的APP或直接使用手机浏览器访问韩漫网址即可。建议在WiFi环境下预加载漫画章节，使用平台的自动滚动功能，调整合适的亮度和字体大小以获得最佳阅读体验。',
  },
  {
    question: '韩漫导航网站是免费的吗？',
    answer: '是的，我们的韩漫导航网站完全免费，旨在为韩漫爱好者提供便捷的平台入口导航服务。我们收录了各大韩漫平台的网址链接，用户可以通过我们的导航快速访问心仪的韩漫平台，无需支付任何费用。',
  },
];